import React, {forwardRef} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import DatePicker from 'react-datepicker';
import LabelInfo from "../LabelInfo";
import LabelInput from "../LabelInput";
import calendar from '../../assets/icon-calender.svg';
import "react-datepicker/dist/react-datepicker.css";
import styles from './styles.module.scss';
import moment from "moment";


const FieldDatepicker = ({
                           fieldId,
                           label,
                           info,
                           containerStyles = null,
                           showIcon = true,
                           disabled = false,
                           onChange,
                           ...rest
                         }) => {
  const CustomInput = forwardRef(
    ({value, onClick, className}, ref) => (
      <div
        className={classnames(
          styles.datepicker,
          {
            [styles.pickerWithIcon]: showIcon,
            [styles.disabled]: disabled,
          },
          className,
        )}
        onClick={onClick}
        ref={ref}
      >
        {value}
        {showIcon && <img src={calendar} alt="calendar" className={styles.iconCalendar}/>}
      </div>
    ),
  );

  const handleDateChange = (form, field) => date => {
    if (onChange) {
      onChange(date);
    }
    form.setFieldValue(field.name, moment(date).toDate())
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field, form, meta}) => (
        <div className={classnames(styles.datepickerContainer, containerStyles)}>
          <div className={styles.labelContainer}>
            <LabelInput label={label}/>
            <LabelInfo label={info} className={styles.remove}/>
          </div>
          <div className={classnames({[styles.pickerWithIcon]: showIcon})}>
            <DatePicker
              className={classnames(styles.datepicker, {[styles.errorBorder]: meta.error && meta.touched})}
              selected={field.value}
              onChange={handleDateChange(form, field)}
              dateFormat="dd/MM/yyyy"
              withPortal={window.innerWidth < 992}
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              customInput={<CustomInput className={classnames({[styles.errorBorder]: meta.error && meta.touched})}/>}
              disabled={disabled}
              {...rest}
            />
          </div>
        </div>
      )}
    </Field>
  )
};

FieldDatepicker.propTypes = {
  fieldId: PropTypes.string.isRequired,
  label: PropTypes.node,
  containerStyles: PropTypes.string,
  showIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default FieldDatepicker;
